export const randomId = ():number => 
    Date.now() + Math.floor(Math.random() * 1000000);
